// src/components/player-profile/FullTabContent.js
//
// Extracted from inline module-level definition in PlayerProfileModal.js
// per IMPORTANT batch 8 commit 8g. Switch dispatcher for the modal's
// full-mode tabs — zero parent closure refs, props-only (10 props all
// declared); no §14.test-infra.4 trivial helper sub-pattern needed
// (no parent-scope helpers used by this body).
//
// Architecture note: PlayerAdvancedAnalytics is always-mounted via the
// display-toggle wrapper (lines below). The 'analytics' switch case
// returns null to avoid double-rendering. See in-body comment for the
// rationale.
import React from 'react';
import PlayerOverviewTab from '../player/PlayerOverviewTab';
import PlayerEligibilityTab from '../player/PlayerEligibilityTab';
import PlayerGameLogsTab from '../player/PlayerGameLogsTab';
import PlayerCareerTab from '../player/PlayerCareerTab';
import PlayerAdvancedAnalytics from '../player/PlayerAdvancedAnalytics';
import PlayerContractTab from '../player/PlayerContractTab';
import PlayerNotesTab from './PlayerNotesTab';

const FullTabContent = ({
  fullTab, player, playerId, leagueId, isPitcher,
  userTeamId, playerNotes, advancedRankingsRef, setAdvancedRankings,
  statsSeasonYear
}) => {
  const tabContent = (() => {
    switch (fullTab) {
      case 'overview':
        return (
          <PlayerOverviewTab
            player={player}
            playerId={playerId}
            leagueId={leagueId}
            isPitcher={isPitcher}
            statsSeasonYear={statsSeasonYear}
          />
        );
      case 'gameLogs':
        return (
          <PlayerGameLogsTab
            playerId={playerId}
            leagueId={leagueId}
            isPitcher={isPitcher}
          />
        );
      case 'career':
        return (
          <PlayerCareerTab
            player={player}
            isPitcher={isPitcher}
          />
        );
      case 'analytics':
        // See always-mounted comment below the return (). Returning null
        // here avoids double-rendering PlayerAdvancedAnalytics.
        return null;
      case 'eligibility':
        return (
          <PlayerEligibilityTab
            player={player}
            statsSeasonYear={statsSeasonYear}
          />
        );
      case 'notes':
        return <PlayerNotesTab notes={playerNotes} player={player} />;
      case 'contract':
        return (
          <PlayerContractTab player={player} leagueStatus={player?.league_status} />
        );
      default:
        return null;
    }
  })();

  return (
    <>
      {/*
        PlayerAdvancedAnalytics is always-mounted via display toggle (not
        unmount/remount per tab switch). Rationale: avoids re-fetching
        analytics data on every tab change. The onDataLoaded callback
        caches the data into advancedRankingsRef.current on first load
        (cache-once via ref); subsequent tab switches are zero-cost CSS
        toggles. The 'analytics' switch case above returns null to avoid
        double-rendering.
      */}
      <div
        data-testid="full-tab-content-analytics-wrapper"
        style={{ display: fullTab === 'analytics' ? 'block' : 'none' }}
      >
        <PlayerAdvancedAnalytics
          playerId={playerId}
          leagueId={leagueId}
          playerName={`${player?.info?.first_name || ''} ${player?.info?.last_name || ''}`.trim()}
          isPitcher={isPitcher}
          teamId={userTeamId}
          currentMarketValue={player?.league_context?.financial?.current_market_value}
          baselinePrice={player?.league_context?.financial?.baseline_price}
          onDataLoaded={(data) => {
            if (!advancedRankingsRef.current) {
              advancedRankingsRef.current = data;
              setAdvancedRankings(data);
            }
          }}
        />
      </div>
      {tabContent}
    </>
  );
};

export default FullTabContent;
